import { css } from 'styled-components';

export const smallOnly = (...args) => css`
  @media (max-width: 640px) {
    ${css(...args)};
  }
`;

export const mediumOnly = (...args) => css`
  @media (min-width: 640px and max-width: 1023px) {
    ${css(...args)};
  }
`;

export const mediumDown = (...args) => css`
  @media (max-width: 1023px) {
    ${css(...args)};
  }
`;

export const mediumUp = (...args) => css`
  @media (min-width: 640px) {
    ${css(...args)};
  }
`;

export const largeOnly = (...args) => css`
  @media (min-width: 1024px and max-width: 1199px) {
    ${css(...args)};
  }
`;

export const largeUp = (...args) => css`
  @media (min-width: 1024px) {
    ${css(...args)};
  }
`;

export const xLargeOnly = (...args) => css`
  @media (min-width: 1200px and max-width: 1439px) {
    ${css(...args)};
  }
`;

export const xLargeUp = (...args) => css`
  @media (min-width: 1200px and max-width: 1439px) {
    ${css(...args)};
  }
`;

export const xxLargeOnly = (...args) => css`
  @media (min-width: 1440px) {
    ${css(...args)};
  }
`;
